import { Button } from "@nimit9/signet-ui/components/button"
import { Card, CardContent, CardHeader, CardTitle } from "@nimit9/signet-ui/components/card"
import { createFileRoute } from "@tanstack/react-router"
import { useInstallPrompt } from "@/hooks/use-install-prompt"
import { useWebPush } from "@/hooks/use-web-push"

export const Route = createFileRoute("/settings/notifications")({
  component: NotificationsTab,
})

function NotificationsTab() {
  const install = useInstallPrompt()
  const push = useWebPush()

  return (
    <div className="max-w-2xl space-y-4">
      <Card>
        <CardHeader className="border-b border-border-subtle px-5 py-4">
          <CardTitle className="text-[14px] font-semibold text-text-primary">Install app</CardTitle>
        </CardHeader>
        <CardContent className="space-y-3 px-5 py-4">
          <p className="text-[13px] text-text-secondary">
            Install Paisa for a full-screen experience and quick home-screen access.
          </p>
          {install.installed ? (
            <p className="text-[13px] text-text-muted">Paisa is installed.</p>
          ) : install.canInstall ? (
            <Button size="sm" onClick={install.promptInstall}>
              Install app
            </Button>
          ) : install.showIosHint ? (
            <p className="text-[13px] text-text-muted">
              On iOS: tap the Share button, then "Add to Home Screen".
            </p>
          ) : (
            <p className="text-[13px] text-text-muted">
              Install isn't available right now (already installed or unsupported browser).
            </p>
          )}
        </CardContent>
      </Card>

      <Card>
        <CardHeader className="border-b border-border-subtle px-5 py-4">
          <CardTitle className="text-[14px] font-semibold text-text-primary">
            Push notifications
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-3 px-5 py-4">
          <p className="text-[13px] text-text-secondary">
            Get budget, bill, and goal alerts pushed to this device — even when the app is closed.
          </p>
          {!push.supported ? (
            <p className="text-[13px] text-text-muted">This browser doesn't support push.</p>
          ) : push.subscribed ? (
            <Button size="sm" variant="outline" onClick={push.unsubscribe}>
              Disable notifications
            </Button>
          ) : (
            <Button size="sm" onClick={push.subscribe}>
              Enable notifications
            </Button>
          )}
          {push.permission === "denied" && (
            <p className="text-[13px] text-text-muted">
              Notifications are blocked in your browser settings.
            </p>
          )}
          {push.error && <p className="text-[13px] text-accent-red">{push.error}</p>}
        </CardContent>
      </Card>
    </div>
  )
}
